import { modalRoutes } from 'constants/routes';
import { createSearchFromParams } from 'utils/url';
import { useNavigate } from 'react-router-dom';
import { ListPost } from 'types/PostDetail';
import { PageData } from 'types/Page';
import { usePostsLayoutState } from './usePostsLayoutState';

const useOpenPost = () => {
  const navigate = useNavigate();
  const isNewPostExperienceActive = usePostsLayoutState(
    (state) => state.isNewPostExperienceActive,
  );

  return (post: {
    id: ListPost['id'];
    page: Pick<PageData, 'isDemo' | 'id'>;
  }) =>
    navigate({
      hash: isNewPostExperienceActive
        ? modalRoutes.POST_DETAIL_NEW
        : modalRoutes.POST_DETAIL,
      search: createSearchFromParams({
        id: post.id,
        pageId: post.page.id,
        demo: post.page.isDemo,
      }),
    });
};

export default useOpenPost;
